// extracted by mini-css-extract-plugin
export var button = "_5u-4";
export var hasDarkBackground = "_5u-7";
export var hasLightBackground = "_5u-6";
export var iconWrapper = "_5u-0";
export var large = "_5u-2";
export var medium = "_5u-1";
export var small = "_5u-5";
export var xsmall = "_5u-3";